(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.cf-item').forEach(function (item) {
      var q = item.querySelector('.cf-q');
      q.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout-styler"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FF_SERIF = "Georgia, serif";
    var FF_SANS = "var(--font-body)";

    function field(r, text, grow) {
      return '<div style="height:34px;border:1px solid var(--void-200);border-radius:' + r +
        'px;padding:0 10px;display:flex;align-items:center;color:var(--void-400);font-size:12px;background:#fff;' +
        (grow ? 'flex:1;' : '') + '">' + text + '</div>';
    }

    function previewCheckout(brand, r, ff, isMobile) {
      var cols = isMobile ? '1fr' : '1.25fr 1fr';
      var items = [['Field Jacket - Olive', '$180.00'], ['Trail Sock 3-pack', '$24.00']];
      var rows = items.map(function (it) {
        return '<div style="display:flex;justify-content:space-between;gap:8px;font-size:12px;color:var(--void-800)">' +
          '<span style="display:flex;gap:8px;align-items:center">' +
          '<span style="width:28px;height:28px;border-radius:' + r + 'px;background:var(--void-200);flex:none"></span>' + it[0] + '</span>' +
          '<span>' + it[1] + '</span></div>';
      }).join('');
      return '<div style="display:grid;grid-template-columns:' + cols + ';gap:20px;font-family:' + ff + '">' +
        '<div style="display:flex;flex-direction:column;gap:10px">' +
        '<div style="font:700 15px ' + ff + ';color:var(--void-950)">Aurora Supply Co.</div>' +
        '<div style="font:600 12px ' + ff + ';color:var(--void-800);margin-top:4px">Contact</div>' +
        field(r, 'Email or mobile number') +
        '<div style="font:600 12px ' + ff + ';color:var(--void-800);margin-top:4px">Delivery</div>' +
        '<div style="display:flex;gap:8px">' + field(r, 'First name', true) + field(r, 'Last name', true) + '</div>' +
        field(r, 'Address') +
        '<div style="height:40px;background:' + brand + ';border-radius:' + r + 'px;display:flex;align-items:center;justify-content:center;color:#fff;font:600 13px ' + ff + ';margin-top:6px">Pay now</div>' +
        '<div style="display:flex;gap:8px;align-items:center;color:var(--void-500);font-size:10.5px"><span>Secure checkout</span><span>·</span><span>45-day returns</span></div>' +
        '</div>' +
        '<div style="background:var(--void-50);border:1px solid var(--void-150);border-radius:' + (r + 2) + 'px;padding:14px;display:flex;flex-direction:column;gap:10px;height:fit-content">' +
        rows +
        '<div style="border-top:1px solid var(--void-150);padding-top:8px;display:flex;justify-content:space-between;font:700 13px ' + ff + ';color:var(--void-950)"><span>Total</span><span>$204.00</span></div>' +
        '</div></div>';
    }

    function previewAccounts(brand, r, ff) {
      return '<div style="font-family:' + ff + ';display:flex;flex-direction:column;gap:14px">' +
        '<div style="display:flex;justify-content:space-between;align-items:baseline">' +
        '<span style="font:700 15px ' + ff + ';color:var(--void-950)">Aurora Supply Co.</span>' +
        '<span style="display:flex;gap:14px;font-size:11.5px;color:var(--void-600)"><span>Orders</span><span>Profile</span><span>Sign out</span></span></div>' +
        '<div><div style="font:700 20px ' + ff + ';color:var(--void-950)">Welcome back, Riley</div>' +
        '<div style="font-size:12px;color:var(--void-600);margin-top:3px">Your orders and account details.</div></div>' +
        '<div style="border:1px solid var(--void-150);border-radius:' + (r + 2) + 'px;padding:14px;display:flex;justify-content:space-between;align-items:center;gap:10px;background:var(--void-50)">' +
        '<span style="display:flex;gap:10px;align-items:center;font-size:12px;color:var(--void-800)">' +
        '<span style="width:32px;height:32px;border-radius:' + r + 'px;background:var(--void-200);flex:none"></span>' +
        '<span><strong style="color:var(--void-950)">Order #1042</strong> · 2 items · $204.00</span></span>' +
        '<span style="background:' + brand + ';color:#fff;border-radius:999px;padding:4px 10px;font-size:10px;font-weight:600;letter-spacing:0.04em">DELIVERED</span></div>' +
        '<div style="display:flex;gap:8px">' +
        '<div style="flex:1;height:38px;background:' + brand + ';border-radius:' + r + 'px;display:flex;align-items:center;justify-content:center;color:#fff;font:600 12.5px ' + ff + '">View all orders</div>' +
        '<div style="flex:1;height:38px;border:1px solid ' + brand + ';border-radius:' + r + 'px;display:flex;align-items:center;justify-content:center;color:' + brand + ';font:600 12.5px ' + ff + ';background:#fff">Edit profile</div>' +
        '</div></div>';
    }

    function previewSignIn(brand, r, ff) {
      return '<div style="font-family:' + ff + ';display:flex;justify-content:center;padding:10px 0">' +
        '<div style="width:100%;max-width:320px;display:flex;flex-direction:column;gap:12px;text-align:center">' +
        '<div style="font:700 15px ' + ff + ';color:var(--void-950)">Aurora Supply Co.</div>' +
        '<div><div style="font:700 17px ' + ff + ';color:var(--void-950)">Sign in</div>' +
        '<div style="font-size:12px;color:var(--void-600);margin-top:3px">We\'ll email you a six-digit code.</div></div>' +
        field(r, 'Email') +
        '<div style="height:38px;background:' + brand + ';border-radius:' + r + 'px;display:flex;align-items:center;justify-content:center;color:#fff;font:600 12.5px ' + ff + '">Continue</div>' +
        '<div style="font-size:10.5px;color:var(--void-500)">Privacy · Terms</div>' +
        '</div></div>';
    }

    function initDemo(root) {
      var state = {
        brand: '#1F7A5C',
        corners: 'Soft',
        r: 8,
        font: 'Sans',
        surface: 'Checkout',
        tokenPath: 'colors.primaryButton.background',
        tokenVal: '#1F7A5C'
      };

      var previewEl = root.querySelector('[data-csp-preview]');
      var pathEl = root.querySelector('[data-csp-readout-path]');
      var valEl = root.querySelector('[data-csp-readout-val]');

      function surfaceKey() {
        return state.surface === 'Checkout' ? 'checkout' : state.surface === 'Accounts' ? 'customerAccounts' : 'signIn';
      }
      function ff() { return state.font === 'Serif' ? FF_SERIF : FF_SANS; }

      function renderPreview() {
        var isMobile = window.innerWidth < 720;
        var html;
        if (state.surface === 'Checkout') html = previewCheckout(state.brand, state.r, ff(), isMobile);
        else if (state.surface === 'Accounts') html = previewAccounts(state.brand, state.r, ff());
        else html = previewSignIn(state.brand, state.r, ff());
        previewEl.innerHTML = html;
      }
      function renderReadout() {
        pathEl.textContent = surfaceKey() + '.' + state.tokenPath;
        valEl.textContent = state.tokenVal;
      }

      // swatches
      root.querySelectorAll('[data-csp-swatches] .csp-swatch').forEach(function (btn) {
        btn.style.outline = btn.classList.contains('is-active') ? '2px solid ' + btn.dataset.color : '1px solid var(--border-strong)';
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-csp-swatches] .csp-swatch').forEach(function (b) {
            b.classList.remove('is-active');
            b.style.outline = '1px solid var(--border-strong)';
          });
          btn.classList.add('is-active');
          btn.style.outline = '2px solid ' + btn.dataset.color;
          state.brand = btn.dataset.color;
          state.tokenPath = 'colors.primaryButton.background';
          state.tokenVal = btn.dataset.color;
          renderPreview();
          renderReadout();
        });
      });

      // corner radius tabs
      root.querySelectorAll('[data-csp-corners] .csp-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-csp-corners] .csp-tab').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.corners = btn.dataset.corner;
          state.r = parseInt(btn.dataset.r, 10);
          state.tokenPath = 'cornerRadius.base';
          state.tokenVal = btn.dataset.token;
          renderPreview();
          renderReadout();
        });
      });

      // typeface select
      var sel = root.querySelector('[data-csp-font]');
      sel.addEventListener('change', function () {
        state.font = sel.value;
        state.tokenPath = 'typography.primary.name';
        state.tokenVal = sel.value === 'Serif' ? 'Georgia' : 'Archivo';
        renderPreview();
        renderReadout();
      });

      // surface tabs
      root.querySelectorAll('[data-csp-surfaces] .csp-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-csp-surfaces] .csp-tab').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.surface = btn.dataset.surface;
          renderPreview();
          renderReadout();
        });
      });

      window.addEventListener('resize', renderPreview);
      renderPreview();
      renderReadout();
    }

    function boot() {
      document.querySelectorAll('[data-csp-demo]').forEach(initDemo);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-pages"]) return;
  try {
    
  document.querySelectorAll('select[data-address-country]').forEach(function (countrySelect) {
    var provinceWrap = document.getElementById(countrySelect.dataset.provinceWrap);
    var provinceSelect = provinceWrap ? provinceWrap.querySelector('select') : null;

    function updateProvinces() {
      if (!provinceSelect) return;
      var option = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try {
        provinces = JSON.parse(option.dataset.provinces || '[]');
      } catch (e) {}
      provinceSelect.innerHTML = '';
      provinces.forEach(function (province) {
        var opt = document.createElement('option');
        opt.value = province[0];
        opt.textContent = province[1];
        if (province[0] === provinceSelect.dataset.default) opt.selected = true;
        provinceSelect.appendChild(opt);
      });
      provinceWrap.hidden = provinces.length === 0;
    }

    var defaultCountry = countrySelect.dataset.default;
    if (defaultCountry) {
      Array.prototype.forEach.call(countrySelect.options, function (opt) {
        if (opt.value === defaultCountry || opt.textContent === defaultCountry) opt.selected = true;
      });
    }
    countrySelect.addEventListener('change', updateProvinces);
    updateProvinces();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-activity"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-st-act]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var ROWS = [
      { name: 'Summit Zip Hoodie', meta: 'Hoodies · Northwind Apparel', add: ['summit', 'collection:summit'], rem: [] },
      { name: 'Coastal Zip Fleece', meta: 'Hoodies · Honeycomb Supply', add: ['sale'], rem: [] },
      { name: 'Trailhead Travel Set', meta: 'Travel Set · Northwind Apparel', add: ['bestseller'], rem: ['new-in'] },
      { name: 'Summit Insulated Flask', meta: 'Accessories · Northwind Apparel', add: ['summit'], rem: [] },
      { name: 'Aurora Desk Lamp', meta: 'Lighting · Acme Widgets Co.', add: ['price-100-plus'], rem: ['sale'] },
      { name: 'Harbour Tee', meta: 'T-Shirts · Honeycomb Supply', add: [], rem: ['sale', 'clearance'] },
      { name: 'Trailhead Rain Jacket', meta: 'Jackets · Northwind Apparel', add: ['weather:waterproof'], rem: [] },
      { name: 'Explorer Gift Set', meta: 'Gifting · Northwind Apparel', add: ['gifting', 'style:gifting'], rem: ['new-in'] }
    ];

    var wrap = root.querySelector('[data-st-act-rows]');
    var search = root.querySelector('[data-st-act-search]');
    var mode = root.querySelector('[data-st-act-mode]');
    var empty = root.querySelector('[data-st-act-empty]');
    var count = root.querySelector('[data-st-act-count]');

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function tags(list, cls, prefix) {
      var cell = el('span', 'st-act__tags');
      if (!list.length) { cell.appendChild(el('span', 'st-act__dash', '-')); return cell; }
      list.forEach(function (t) { cell.appendChild(el('span', 'st-act__tag ' + cls, prefix + t)); });
      return cell;
    }

    ROWS.forEach(function (r) {
      var row = el('div', 'st-act__row');
      row.dataset.search = (r.name + ' ' + r.meta + ' ' + r.add.join(' ') + ' ' + r.rem.join(' ')).toLowerCase();
      row.dataset.add = r.add.length ? '1' : '0';
      row.dataset.rem = r.rem.length ? '1' : '0';
      var name = el('span', 'st-act__name', r.name);
      name.appendChild(el('span', 'st-act__meta', r.meta));
      row.appendChild(name);
      row.appendChild(tags(r.add, 'st-act__tag--add', '+ '));
      row.appendChild(tags(r.rem, 'st-act__tag--rem', '− '));
      wrap.appendChild(row);
    });

    var rows = Array.prototype.slice.call(wrap.children);

    function apply() {
      var q = search.value.trim().toLowerCase();
      var m = mode.value;
      var shown = 0;
      rows.forEach(function (row) {
        var ok = row.dataset.search.indexOf(q) !== -1;
        if (m === 'added' && row.dataset.add === '0') ok = false;
        if (m === 'removed' && row.dataset.rem === '0') ok = false;
        row.hidden = !ok;
        if (ok) shown++;
      });
      empty.hidden = shown !== 0;
      count.textContent = shown + ' of ' + rows.length + ' products';
    }

    search.addEventListener('input', apply);
    mode.addEventListener('change', apply);
    apply();

    // Scripted autoplay steps for the shared st-demo-autoplay engine
    // (data-st-autoplay="@steps"): walk through the filter and a couple of
    // searches, then reset. The engine handles timing, fade, the badge and
    // stopping on real interaction.
    var STEPS = [
      function () { search.value = ''; mode.value = 'added'; },
      function () { mode.value = 'removed'; },
      function () { mode.value = 'all'; search.value = 'summit'; },
      function () { search.value = 'sale'; },
      function () { search.value = ''; mode.value = 'all'; }
    ];
    var stepIdx = -1;
    root.__stAutoplayStep = function () {
      stepIdx = (stepIdx + 1) % STEPS.length;
      STEPS[stepIdx]();
      apply();
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-ai-draft"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-st-ai]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var PRODUCTS = [
      { name: 'Summit Zip Hoodie', type: 'Hoodies', vendor: 'Northwind Apparel', price: 79, compareAt: 99, inventory: 17, status: 'Active', tags: ['hoodies'] },
      { name: 'Coastal Zip Fleece', type: 'Hoodies', vendor: 'Honeycomb Supply', price: 64, compareAt: null, inventory: 0, status: 'Active', tags: ['fleece'] },
      { name: 'Trailhead Travel Set', type: 'Travel Set', vendor: 'Northwind Apparel', price: 129, compareAt: null, inventory: 42, status: 'Active', tags: ['bestseller'] },
      { name: 'Summit Insulated Flask', type: 'Accessories', vendor: 'Northwind Apparel', price: 24, compareAt: null, inventory: 5, status: 'Draft', tags: [] },
      { name: 'Aurora Desk Lamp', type: 'Lighting', vendor: 'Acme Widgets Co.', price: 149, compareAt: 189, inventory: 3, status: 'Active', tags: ['new-in'] },
      { name: 'Harbour Tee', type: 'T-Shirts', vendor: 'Honeycomb Supply', price: 19, compareAt: null, inventory: 120, status: 'Active', tags: [] }
    ];

    function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

    var PRESETS = {
      budget: {
        prompt: 'Tag anything under $70 from Honeycomb Supply as a budget pick',
        kw: ['budget', 'cheap', 'under', 'affordable'],
        rule: [
          { step: 'WHEN' }, { chip: 'Vendor is Honeycomb Supply' }, { chip: 'Price < 70' },
          { step: 'THEN' }, { tag: 'budget-pick' }
        ],
        why: 'Two conditions joined with ALL - a vendor match plus a price ceiling. The tag only sticks while both stay true.',
        matches: function (p) { return p.vendor === 'Honeycomb Supply' && p.price < 70; },
        tagsFor: function () { return ['budget-pick']; }
      },
      typetag: {
        prompt: 'Tag every product with its product type, like type:hoodies',
        kw: ['type', 'category', 'every product', 'all products'],
        rule: [
          { step: 'WHEN' }, { chip: 'any product' },
          { step: 'THEN' }, { tag: 'type:' + '{' + '{ type | handleize }' + '}' }
        ],
        why: 'A dynamic tag - the value comes from each product, handleized so "Travel Set" becomes type:travel-set.',
        matches: function () { return true; },
        tagsFor: function (p) { return ['type:' + handleize(p.type)]; }
      },
      salebands: {
        prompt: 'Tag on-sale items with the discount depth in 10% bands',
        kw: ['sale', 'discount', 'band', '% off', 'percent'],
        rule: [
          { step: 'WHEN' }, { chip: 'Compare At Price > Price' },
          { step: 'THEN' }, { tag: 'sale-{band}' }
        ],
        why: 'Discount depth is computed from compare-at vs price and rounded down to a 10% band - the AI drafts this one into Liquid mode because the visual builder cannot do the math.',
        matches: function (p) { return p.compareAt && p.compareAt > p.price; },
        tagsFor: function (p) {
          var pct = Math.floor(((p.compareAt - p.price) / p.compareAt) * 100);
          return ['sale-' + (Math.floor(pct / 10) * 10)];
        }
      },
      attention: {
        prompt: 'Flag products that are out of stock or still in draft',
        kw: ['stock', 'draft', 'attention', 'flag', 'sold out'],
        rule: [
          { step: 'WHEN' }, { chip: 'Inventory = 0' }, { chip: 'OR Status is Draft' },
          { step: 'THEN' }, { tag: 'needs-attention' }
        ],
        why: 'Two conditions joined with ANY - either one is enough. The tag drops off on its own once stock returns or the product goes live.',
        matches: function (p) { return p.inventory === 0 || p.status === 'Draft'; },
        tagsFor: function () { return ['needs-attention']; }
      },
      premium: {
        prompt: 'Tag active products over $100 as premium',
        kw: ['premium', 'expensive', 'over', 'high end', 'luxury'],
        rule: [
          { step: 'WHEN' }, { chip: 'Price > 100' }, { chip: 'Status is Active' },
          { step: 'THEN' }, { tag: 'premium' }
        ],
        why: 'A price floor plus a status guard, so drafts and archived products never pick up the tag.',
        matches: function (p) { return p.price > 100 && p.status === 'Active'; },
        tagsFor: function () { return ['premium']; }
      }
    };

    var chat = root.querySelector('[data-st-ai-chat]');
    var form = root.querySelector('[data-st-ai-form]');
    var input = root.querySelector('[data-st-ai-input]');
    var counter = root.querySelector('[data-st-ai-count]');
    var summary = root.querySelector('[data-st-ai-summary]');
    var prodWrap = root.querySelector('[data-st-ai-products]');

    var draftsLeft = 148;
    var busy = false;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function renderCount() { counter.textContent = draftsLeft + ' of 150 drafts left this month'; }

    function showEmpty() {
      chat.innerHTML = '';
      var e = document.createElement('div');
      e.className = 'st-ai__empty';
      e.innerHTML = '<span class="st-ai__empty-spark" aria-hidden="true">&#10022;</span>Describe the rule you want and it drafts into the editor - e.g. "tag anything under $50 from Nike as a budget pick".';
      chat.appendChild(e);
    }

    function bubble(cls, text) {
      var empty = chat.querySelector('.st-ai__empty');
      if (empty) empty.remove();
      var el = document.createElement('div');
      el.className = 'st-ai__msg ' + cls;
      el.textContent = text;
      chat.appendChild(el);
      chat.scrollTop = chat.scrollHeight;
      return el;
    }

    function money(n) { return '$' + n; }

    function renderPreview(preset) {
      prodWrap.innerHTML = '';
      var count = 0;
      PRODUCTS.forEach(function (p) {
        var hit = preset ? preset.matches(p) : false;
        if (hit) count++;
        var card = document.createElement('div');
        card.className = 'st-demo__product ' + (preset ? (hit ? 'is-match' : 'is-miss') : '');

        var name = document.createElement('div');
        name.className = 'st-demo__pname'; name.textContent = p.name;
        var meta = document.createElement('div');
        meta.className = 'st-demo__pmeta';
        meta.textContent = p.type + ' · ' + p.vendor + ' · ' + money(p.price)
          + (p.compareAt ? ' (was ' + money(p.compareAt) + ')' : '')
          + ' · ' + p.inventory + ' in stock · ' + p.status;

        var tags = document.createElement('div');
        tags.className = 'st-demo__ptags';
        p.tags.forEach(function (t) {
          var el = document.createElement('span');
          el.className = 'st-demo__ptag'; el.textContent = t;
          tags.appendChild(el);
        });
        if (hit) {
          preset.tagsFor(p).forEach(function (t) {
            var el = document.createElement('span');
            el.className = 'st-demo__ptag st-demo__ptag--new'; el.textContent = '+ ' + t;
            tags.appendChild(el);
          });
        }

        card.appendChild(name); card.appendChild(meta); card.appendChild(tags);
        prodWrap.appendChild(card);
      });
      if (preset) {
        summary.innerHTML = '<b>' + count + ' of ' + PRODUCTS.length + '</b> demo products match the drafted rule.';
      }
    }

    function draftCard(preset) {
      var empty = chat.querySelector('.st-ai__empty');
      if (empty) empty.remove();
      var card = document.createElement('div');
      card.className = 'st-ai__msg st-ai__draft';

      var head = document.createElement('div');
      head.className = 'st-ai__draft-head';
      head.textContent = 'Rule is ready';
      card.appendChild(head);

      var rule = document.createElement('div');
      rule.className = 'st-ai__draft-rule';
      preset.rule.forEach(function (part) {
        var el;
        if (part.step) {
          el = document.createElement('span');
          el.className = 'st-demo__step ' + (part.step === 'WHEN' ? 'st-demo__step--when' : 'st-demo__step--then');
          el.textContent = part.step;
        } else {
          el = document.createElement('span');
          el.className = 'st-ai__draft-chip' + (part.tag ? ' st-ai__draft-chip--tag' : '');
          el.textContent = part.tag ? '+ ' + part.tag : part.chip;
        }
        rule.appendChild(el);
      });
      card.appendChild(rule);

      var why = document.createElement('p');
      why.className = 'st-ai__draft-why';
      why.textContent = preset.why;
      card.appendChild(why);

      chat.appendChild(card);
      chat.scrollTop = chat.scrollHeight;
    }

    function typeInto(text, done) {
      if (reduceMotion) { input.value = text; done(); return; }
      input.value = '';
      var i = 0;
      var t = setInterval(function () {
        i += 2;
        input.value = text.slice(0, i);
        if (i >= text.length) { clearInterval(t); done(); }
      }, 18);
    }

    function runDraft(preset, promptText) {
      busy = true;
      bubble('st-ai__msg--user', promptText);
      input.value = '';
      var status = bubble('st-ai__msg--status', '');
      status.innerHTML = '<span class="st-ai__spark" aria-hidden="true">&#10022;</span>Drafting...';
      setTimeout(function () {
        status.remove();
        draftCard(preset);
        renderPreview(preset);
        if (draftsLeft > 140) { draftsLeft--; renderCount(); }
        busy = false;
      }, reduceMotion ? 200 : 1000);
    }

    function matchPreset(text) {
      var t = text.toLowerCase();
      var best = null, bestScore = 0;
      Object.keys(PRESETS).forEach(function (k) {
        var score = 0;
        PRESETS[k].kw.forEach(function (kw) { if (t.indexOf(kw) !== -1) score++; });
        if (score > bestScore) { bestScore = score; best = PRESETS[k]; }
      });
      return best;
    }

    root.querySelectorAll('[data-st-ai-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        var preset = PRESETS[btn.dataset.stAiPreset];
        if (!preset) return;
        busy = true;
        typeInto(preset.prompt, function () { runDraft(preset, preset.prompt); });
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var text = (input.value || '').trim();
      if (!text) return;
      var preset = matchPreset(text);
      if (preset) {
        runDraft(preset, text);
      } else {
        bubble('st-ai__msg--user', text);
        input.value = '';
        bubble('st-ai__msg--note', 'This demo replays five real drafts - try one of the prompts above. In the app, you can ask for anything and refine it with follow-ups.');
      }
    });

    renderCount();
    showEmpty();
    renderPreview(null);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-field-tags"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-st-ft]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var PRODUCTS = [
      { name: 'Summit Zip Hoodie', type: 'Hoodies', vendor: 'Northwind Apparel', price: 79, status: 'Active', tags: ['hoodies'] },
      { name: 'Coastal Zip Fleece', type: 'Hoodies', vendor: 'Honeycomb Supply', price: 64, status: 'Active', tags: ['fleece'] },
      { name: 'Trailhead Travel Set', type: 'Travel Set', vendor: 'Northwind Apparel', price: 129, status: 'Active', tags: ['bestseller'] },
      { name: 'Summit Insulated Flask', type: 'Accessories', vendor: 'Northwind Apparel', price: 24, status: 'Draft', tags: [] },
      { name: 'Aurora Desk Lamp', type: 'Lighting', vendor: 'Acme Widgets Co.', price: 149, status: 'Active', tags: ['new-in'] },
      { name: 'Harbour Tee', type: 'T-Shirts', vendor: 'Honeycomb Supply', price: 19, status: 'Active', tags: [] }
    ];

    var FIELDS = [
      { key: 'vendor', label: 'Vendor' },
      { key: 'type', label: 'Product Type' },
      { key: 'name', label: 'Title' },
      { key: 'status', label: 'Status' },
      { key: 'price', label: 'Price' }
    ];

    var FILTERS = [
      { kind: 'downcase', label: 'Lowercase' },
      { kind: 'upcase', label: 'Uppercase' },
      { kind: 'handleize', label: 'Handleize' },
      { kind: 'replace', label: 'Replace', fromTo: true },
      { kind: 'truncate', label: 'Truncate', length: true }
    ];

    // Faithful port of the app's filter pipeline (fieldFilters.ts subset):
    // ordered filters first, then literal prepend/append around the result.
    function handleize(s) {
      return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function applyFilter(v, f) {
      if (f.kind === 'downcase') return v.toLowerCase();
      if (f.kind === 'upcase') return v.toUpperCase();
      if (f.kind === 'handleize') return handleize(v);
      if (f.kind === 'replace') { if (!f.from) return v; return v.split(f.from).join(f.to || ''); }
      if (f.kind === 'truncate') {
        var n = parseInt(f.length, 10);
        if (isNaN(n) || n < 0) return v;
        return v.length > n ? v.slice(0, n) : v;
      }
      return v;
    }
    function tagFor(product, ft) {
      var raw = String(product[ft.key] == null ? '' : product[ft.key]);
      if (!raw) return '';
      var out = raw;
      for (var i = 0; i < ft.filters.length; i++) out = applyFilter(out, ft.filters[i]);
      return ((ft.prepend || '') + out + (ft.append || '')).trim();
    }

    // state.fields: [{ key, prepend, append, filters: [{kind, from, to, length}], open }]
    var state = { fields: [] };

    var pickRow = root.querySelector('[data-st-ft-pick]');
    var chipWrap = root.querySelector('[data-st-ft-chips]');
    var prodWrap = root.querySelector('[data-st-ft-products]');
    var summary = root.querySelector('[data-st-ft-summary]');

    function fieldDef(k) { for (var i = 0; i < FIELDS.length; i++) if (FIELDS[i].key === k) return FIELDS[i]; return FIELDS[0]; }
    function filterDef(k) { for (var i = 0; i < FILTERS.length; i++) if (FILTERS[i].kind === k) return FILTERS[i]; return null; }
    function selected(k) { return state.fields.some(function (f) { return f.key === k; }); }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function render() {
      // field picker pills
      pickRow.querySelectorAll('button').forEach(function (b) { b.remove(); });
      FIELDS.forEach(function (f) {
        var b = el('button', null, '+ ' + f.label);
        b.type = 'button';
        b.disabled = selected(f.key) || state.fields.length >= 4;
        b.addEventListener('click', function () {
          state.fields.push({ key: f.key, prepend: '', append: '', filters: [], open: false });
          render();
        });
        pickRow.appendChild(b);
      });

      // selected field chips
      chipWrap.innerHTML = '';
      if (!state.fields.length) {
        chipWrap.appendChild(el('div', 'st-ft__empty', 'No fields selected yet. Add one above, or try a preset.'));
      }
      state.fields.forEach(function (ft, i) {
        var def = fieldDef(ft.key);
        var chip = el('div', 'st-ft__chip' + (ft.open ? ' is-open' : ''));
        var row = el('div', 'st-ft__chiprow');
        row.appendChild(el('span', 'st-ft__chipname', def.label));

        // live value flow for the first demo product, like the app's chip preview
        var raw = String(PRODUCTS[0][ft.key]);
        var result = tagFor(PRODUCTS[0], ft);
        var flow = el('span', 'st-ft__flow');
        flow.appendChild(el('span', 'st-ft__flow-raw', raw));
        flow.appendChild(el('span', 'st-ft__flow-arrow', '→'));
        if (result) flow.appendChild(el('span', 'st-ft__flow-tag', result));
        else flow.appendChild(el('span', 'st-ft__flow-empty', '(empty - no tag)'));
        row.appendChild(flow);

        var btns = el('span', 'st-ft__chipbtns');
        var fbtn = el('button', null, (ft.open ? 'Done' : 'Filter'));
        fbtn.type = 'button';
        fbtn.title = "Transform this field's value before tagging";
        fbtn.addEventListener('click', function () { ft.open = !ft.open; render(); });
        var xbtn = el('button', 'st-ft__remove', '× Remove');
        xbtn.type = 'button';
        xbtn.addEventListener('click', function () { state.fields.splice(i, 1); render(); });
        btns.appendChild(fbtn); btns.appendChild(xbtn);
        row.appendChild(btns);
        chip.appendChild(row);

        if (ft.open) chip.appendChild(renderPanel(ft));
        chipWrap.appendChild(chip);
      });

      renderPreview();
    }

    function renderPanel(ft) {
      var panel = el('div', 'st-ft__panel');

      var pa = el('div', 'st-ft__pa');
      [['prepend', 'Prepend', 'e.g. brand-'], ['append', 'Append', 'e.g. -2026']].forEach(function (spec) {
        var lab = el('label', null, null);
        lab.appendChild(document.createTextNode(spec[1]));
        var inp = document.createElement('input');
        inp.type = 'text'; inp.maxLength = 20; inp.placeholder = spec[2]; inp.value = ft[spec[0]];
        inp.addEventListener('input', function () { ft[spec[0]] = inp.value; softRender(ft); });
        lab.appendChild(inp);
        pa.appendChild(lab);
      });
      panel.appendChild(pa);

      panel.appendChild(el('div', 'st-ft__fhead', 'Filters (applied in order)'));
      var pipe = el('div', 'st-ft__pipeline');
      ft.filters.forEach(function (f, j) {
        var d = filterDef(f.kind);
        var step = el('div', 'st-ft__fstep');
        step.appendChild(el('span', null, (j + 1) + '. ' + d.label));
        if (d.fromTo) {
          var from = document.createElement('input');
          from.type = 'text'; from.placeholder = 'find'; from.value = f.from || ''; from.maxLength = 20;
          from.addEventListener('input', function () { f.from = from.value; softRender(ft); });
          var to = document.createElement('input');
          to.type = 'text'; to.placeholder = 'replace with'; to.value = f.to || ''; to.maxLength = 20;
          to.addEventListener('input', function () { f.to = to.value; softRender(ft); });
          step.appendChild(from); step.appendChild(to);
        }
        if (d.length) {
          var len = document.createElement('input');
          len.type = 'number'; len.min = 0; len.placeholder = 'max length'; len.value = f.length == null ? '' : f.length;
          len.addEventListener('input', function () { f.length = len.value; softRender(ft); });
          step.appendChild(len);
        }
        var x = el('button', 'st-ft__fx', '×');
        x.type = 'button'; x.setAttribute('aria-label', 'Remove ' + d.label + ' filter');
        x.addEventListener('click', function () { ft.filters.splice(j, 1); render(); });
        step.appendChild(x);
        pipe.appendChild(step);
      });
      panel.appendChild(pipe);

      var add = el('div', 'st-ft__addfilters');
      FILTERS.forEach(function (d) {
        var b = el('button', null, '+ ' + d.label);
        b.type = 'button';
        var repeatable = d.kind === 'replace';
        b.disabled = (!repeatable && ft.filters.some(function (f) { return f.kind === d.kind; })) || ft.filters.length >= 4;
        b.addEventListener('click', function () { ft.filters.push({ kind: d.kind, from: '', to: '', length: '' }); render(); });
        add.appendChild(b);
      });
      panel.appendChild(add);
      return panel;
    }

    // Re-render only the preview and this chip's flow line while typing, so
    // the input being typed in never loses focus to a full re-render.
    function softRender(ft) {
      var idx = state.fields.indexOf(ft);
      var chip = chipWrap.children[idx];
      if (chip) {
        var flow = chip.querySelector('.st-ft__flow');
        if (flow) {
          var result = tagFor(PRODUCTS[0], ft);
          flow.innerHTML = '';
          flow.appendChild(el('span', 'st-ft__flow-raw', String(PRODUCTS[0][ft.key])));
          flow.appendChild(el('span', 'st-ft__flow-arrow', '→'));
          if (result) flow.appendChild(el('span', 'st-ft__flow-tag', result));
          else flow.appendChild(el('span', 'st-ft__flow-empty', '(empty - no tag)'));
        }
      }
      renderPreview();
    }

    function renderPreview() {
      prodWrap.innerHTML = '';
      var distinct = {};
      PRODUCTS.forEach(function (p) {
        var card = el('div', 'st-demo__product');
        card.appendChild(el('div', 'st-demo__pname', p.name));
        card.appendChild(el('div', 'st-demo__pmeta', p.type + ' · ' + p.vendor + ' · $' + p.price + ' · ' + p.status));

        var tags = el('div', 'st-demo__ptags');
        p.tags.forEach(function (t) { tags.appendChild(el('span', 'st-demo__ptag', t)); });
        var seen = {};
        state.fields.forEach(function (ft) {
          var t = tagFor(p, ft);
          if (!t || seen[t]) return;
          seen[t] = true;
          distinct[t] = true;
          tags.appendChild(el('span', 'st-demo__ptag st-demo__ptag--new', '+ ' + t));
        });
        card.appendChild(tags);
        prodWrap.appendChild(card);
      });

      var n = Object.keys(distinct).length;
      if (!state.fields.length) {
        summary.textContent = 'Add a field on the left and every demo product gets a tag made from its own value.';
      } else {
        summary.innerHTML = state.fields.length + (state.fields.length === 1 ? ' dynamic tag makes ' : ' dynamic tags make ')
          + '<b>' + n + ' distinct tag' + (n === 1 ? '' : 's') + '</b> across ' + PRODUCTS.length + ' demo products.';
      }
      syncPresets();
    }

    // Preset pills highlight only while the config still IS that preset -
    // derived from state so editing anything clears the highlight.
    var PRESETS = {
      brand: { fields: [{ key: 'vendor', prepend: 'brand-', append: '', filters: [{ kind: 'handleize' }] }] },
      type: { fields: [{ key: 'type', prepend: '', append: '', filters: [{ kind: 'handleize' }] }] },
      status: { fields: [{ key: 'status', prepend: '', append: '', filters: [{ kind: 'downcase' }] }] },
      clean: { fields: [{ key: 'vendor', prepend: 'brand-', append: '', filters: [{ kind: 'replace', from: ' Apparel', to: '' }, { kind: 'handleize' }] }] },
      price: { fields: [{ key: 'price', prepend: 'price-', append: '', filters: [] }] },
      combo: {
        fields: [
          { key: 'vendor', prepend: '', append: '', filters: [{ kind: 'handleize' }] },
          { key: 'type', prepend: '', append: '', filters: [{ kind: 'handleize' }] }
        ]
      }
    };

    function norm(fields) {
      return JSON.stringify(fields.map(function (f) {
        return {
          k: f.key, p: f.prepend || '', a: f.append || '',
          f: (f.filters || []).map(function (x) {
            return { k: x.kind, f: x.from || '', t: x.to || '', l: String(x.length == null ? '' : x.length) };
          })
        };
      }));
    }
    function syncPresets() {
      var cur = norm(state.fields);
      root.querySelectorAll('[data-st-ft-preset]').forEach(function (btn) {
        var p = PRESETS[btn.dataset.stFtPreset];
        btn.classList.toggle('is-active', !!p && norm(p.fields) === cur);
      });
    }

    root.querySelectorAll('[data-st-ft-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = PRESETS[btn.dataset.stFtPreset];
        if (!p) return;
        state.fields = p.fields.map(function (f) {
          return {
            key: f.key, prepend: f.prepend || '', append: f.append || '',
            filters: (f.filters || []).map(function (x) { return { kind: x.kind, from: x.from || '', to: x.to || '', length: x.length == null ? '' : x.length }; }),
            open: false
          };
        });
        render();
      });
    });

    // start on the brand preset so the demo lands populated
    state.fields = PRESETS.brand.fields.map(function (f) {
      return { key: f.key, prepend: f.prepend, append: f.append, filters: f.filters.map(function (x) { return { kind: x.kind, from: x.from || '', to: x.to || '', length: '' }; }), open: false };
    });
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-rules-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-st-demo]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var PRODUCTS = [
      { name: 'Summit Zip Hoodie', type: 'Hoodies', vendor: 'Northwind Apparel', price: 79, compareAt: 99, inventory: 17, status: 'Active', tags: ['hoodies'] },
      { name: 'Coastal Zip Fleece', type: 'Hoodies', vendor: 'Honeycomb Supply', price: 64, compareAt: null, inventory: 0, status: 'Active', tags: ['fleece'] },
      { name: 'Trailhead Travel Set', type: 'Travel Set', vendor: 'Northwind Apparel', price: 129, compareAt: null, inventory: 42, status: 'Active', tags: ['bestseller'] },
      { name: 'Summit Insulated Flask', type: 'Accessories', vendor: 'Northwind Apparel', price: 24, compareAt: null, inventory: 5, status: 'Draft', tags: [] },
      { name: 'Aurora Desk Lamp', type: 'Lighting', vendor: 'Acme Widgets Co.', price: 149, compareAt: 189, inventory: 3, status: 'Active', tags: ['new-in'] },
      { name: 'Harbour Tee', type: 'T-Shirts', vendor: 'Honeycomb Supply', price: 19, compareAt: null, inventory: 120, status: 'Active', tags: [] }
    ];

    var FIELDS = [
      { key: 'type', label: 'Product Type', kind: 'text', defaultOp: 'eq' },
      { key: 'vendor', label: 'Vendor', kind: 'text', defaultOp: 'eq' },
      { key: 'name', label: 'Title', kind: 'text', defaultOp: 'contains' },
      { key: 'price', label: 'Price', kind: 'number', defaultOp: 'gt' },
      { key: 'compareAt', label: 'Compare At Price', kind: 'number', defaultOp: 'notempty' },
      { key: 'inventory', label: 'Total Inventory', kind: 'number', defaultOp: 'eq' },
      { key: 'status', label: 'Status', kind: 'text', defaultOp: 'eq' }
    ];

    var OPS = [
      { key: 'eq', label: 'is equal to' },
      { key: 'neq', label: 'is not equal to' },
      { key: 'contains', label: 'contains' },
      { key: 'gt', label: 'is greater than' },
      { key: 'lt', label: 'is less than' },
      { key: 'empty', label: 'is empty' },
      { key: 'notempty', label: 'is not empty' }
    ];

    var state = {
      mode: 'all',
      conditions: [{ field: 'compareAt', op: 'notempty', value: '' }],
      tags: ['sale']
    };

    var condWrap = root.querySelector('[data-st-conditions]');
    var tagWrap = root.querySelector('[data-st-tags]');
    var prodWrap = root.querySelector('[data-st-products]');
    var summary = root.querySelector('[data-st-summary]');
    var tagInput = root.querySelector('[data-st-taginput]');

    function fieldByKey(k) { for (var i = 0; i < FIELDS.length; i++) if (FIELDS[i].key === k) return FIELDS[i]; return FIELDS[0]; }

    function evalCondition(p, c) {
      var raw = p[c.field];
      var isEmpty = raw === null || raw === undefined || raw === '';
      if (c.op === 'empty') return isEmpty;
      if (c.op === 'notempty') return !isEmpty;
      if (isEmpty) return false;
      var kind = fieldByKey(c.field).kind;
      if (kind === 'number') {
        var v = parseFloat(c.value);
        if (isNaN(v)) return false;
        if (c.op === 'gt') return raw > v;
        if (c.op === 'lt') return raw < v;
        if (c.op === 'eq') return raw === v;
        if (c.op === 'neq') return raw !== v;
        if (c.op === 'contains') return String(raw).indexOf(c.value) !== -1;
        return false;
      }
      var a = String(raw).toLowerCase();
      var b = String(c.value || '').toLowerCase();
      if (c.op === 'eq') return a === b;
      if (c.op === 'neq') return a !== b;
      if (c.op === 'contains') return b !== '' && a.indexOf(b) !== -1;
      if (c.op === 'gt') return a > b;
      if (c.op === 'lt') return a < b;
      return false;
    }

    function matches(p) {
      var usable = state.conditions.filter(function (c) {
        return c.op === 'empty' || c.op === 'notempty' || String(c.value).trim() !== '';
      });
      if (!usable.length) return false;
      var results = usable.map(function (c) { return evalCondition(p, c); });
      return state.mode === 'all'
        ? results.every(function (r) { return r; })
        : results.some(function (r) { return r; });
    }

    function money(n) { return '$' + n; }

    function render() {
      // conditions
      condWrap.innerHTML = '';
      state.conditions.forEach(function (c, i) {
        var box = document.createElement('div');
        box.className = 'st-demo__cond';

        var fieldSel = document.createElement('select');
        FIELDS.forEach(function (f) {
          var o = document.createElement('option');
          o.value = f.key; o.textContent = f.label; if (f.key === c.field) o.selected = true;
          fieldSel.appendChild(o);
        });
        fieldSel.addEventListener('change', function () {
          c.field = fieldSel.value;
          c.op = fieldByKey(c.field).defaultOp;
          c.value = '';
          render();
        });

        var row = document.createElement('div');
        row.className = 'st-demo__condrow';
        var opSel = document.createElement('select');
        OPS.forEach(function (op) {
          var o = document.createElement('option');
          o.value = op.key; o.textContent = op.label; if (op.key === c.op) o.selected = true;
          opSel.appendChild(o);
        });
        opSel.addEventListener('change', function () { c.op = opSel.value; render(); });

        var val = document.createElement('input');
        val.type = fieldByKey(c.field).kind === 'number' ? 'number' : 'text';
        val.placeholder = 'Enter a value...';
        val.value = c.value;
        val.disabled = c.op === 'empty' || c.op === 'notempty';
        if (val.disabled) val.placeholder = 'No value needed';
        val.addEventListener('input', function () { c.value = val.value; renderPreview(); });

        row.appendChild(opSel); row.appendChild(val);
        box.appendChild(fieldSel); box.appendChild(row);

        if (!val.disabled) {
          var kind = fieldByKey(c.field).kind;
          var seen = {};
          var options = [];
          PRODUCTS.forEach(function (p) {
            var v = p[c.field];
            if (v === null || v === undefined || v === '') return;
            if (seen[v]) return;
            seen[v] = true;
            options.push(v);
          });
          if (kind === 'number') options.sort(function (a, b) { return a - b; });
          else options.sort();
          if (options.length) {
            var sug = document.createElement('div');
            sug.className = 'st-demo__suggest';
            options.slice(0, 6).forEach(function (v) {
              var b = document.createElement('button');
              b.type = 'button';
              b.textContent = kind === 'number' ? v : String(v);
              if (String(v) === String(c.value)) b.className = 'is-active';
              b.addEventListener('click', function () { c.value = String(v); render(); });
              sug.appendChild(b);
            });
            box.appendChild(sug);
          }
        }

        if (state.conditions.length > 1) {
          var rm = document.createElement('button');
          rm.type = 'button'; rm.className = 'st-demo__removecond'; rm.textContent = '×';
          rm.setAttribute('aria-label', 'Remove condition');
          rm.addEventListener('click', function () { state.conditions.splice(i, 1); render(); });
          box.appendChild(rm);
        }
        condWrap.appendChild(box);
      });

      // tags
      tagWrap.innerHTML = '';
      state.tags.forEach(function (t, i) {
        var chip = document.createElement('span');
        chip.className = 'st-demo__tagchip';
        chip.textContent = t + ' ';
        var x = document.createElement('button');
        x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', 'Remove ' + t);
        x.addEventListener('click', function () { state.tags.splice(i, 1); render(); });
        chip.appendChild(x);
        tagWrap.appendChild(chip);
      });

      renderPreview();
    }

    function renderPreview() {
      prodWrap.innerHTML = '';
      var count = 0;
      PRODUCTS.forEach(function (p) {
        var hit = matches(p);
        if (hit) count++;
        var card = document.createElement('div');
        card.className = 'st-demo__product ' + (hit ? 'is-match' : 'is-miss');

        var name = document.createElement('div');
        name.className = 'st-demo__pname'; name.textContent = p.name;
        var meta = document.createElement('div');
        meta.className = 'st-demo__pmeta';
        meta.textContent = p.type + ' · ' + p.vendor + ' · ' + money(p.price)
          + (p.compareAt ? ' (was ' + money(p.compareAt) + ')' : '')
          + ' · ' + p.inventory + ' in stock · ' + p.status;

        var tags = document.createElement('div');
        tags.className = 'st-demo__ptags';
        p.tags.forEach(function (t) {
          var el = document.createElement('span');
          el.className = 'st-demo__ptag'; el.textContent = t;
          tags.appendChild(el);
        });
        if (hit) {
          state.tags.forEach(function (t) {
            var el = document.createElement('span');
            el.className = 'st-demo__ptag st-demo__ptag--new'; el.textContent = '+ ' + t;
            tags.appendChild(el);
          });
        }

        card.appendChild(name); card.appendChild(meta); card.appendChild(tags);
        prodWrap.appendChild(card);
      });
      summary.innerHTML = '<b>' + count + ' of ' + PRODUCTS.length + '</b> demo products match this rule' + (state.tags.length ? '' : ' - add a tag to apply it') + '.';
      syncPresets();
    }

    // A preset pill stays highlighted only while the rule still IS that preset:
    // the active state is derived from the current mode / conditions / tags, so
    // editing any value the preset filled in clears the highlight.
    function normValue(c) {
      if (c.op === 'empty' || c.op === 'notempty') return '';
      return String(c.value == null ? '' : c.value).trim().toLowerCase();
    }

    function stateMatchesPreset(p) {
      if (state.mode !== p.mode) return false;
      if (state.conditions.length !== p.conditions.length) return false;
      for (var i = 0; i < p.conditions.length; i++) {
        var a = state.conditions[i], b = p.conditions[i];
        if (a.field !== b.field || a.op !== b.op || normValue(a) !== normValue(b)) return false;
      }
      var at = state.tags.slice().sort();
      var bt = p.tags.slice().sort();
      if (at.length !== bt.length) return false;
      for (var j = 0; j < at.length; j++) if (at[j] !== bt[j]) return false;
      return true;
    }

    function syncPresets() {
      root.querySelectorAll('[data-st-preset]').forEach(function (btn) {
        var p = PRESETS[btn.dataset.stPreset];
        btn.classList.toggle('is-active', !!p && stateMatchesPreset(p));
      });
    }

    function addTag() {
      var t = (tagInput.value || '').trim().toLowerCase().replace(/\s+/g, '-');
      if (!t || state.tags.indexOf(t) !== -1 || state.tags.length >= 4) { tagInput.value = ''; return; }
      state.tags.push(t); tagInput.value = ''; render();
    }

    root.querySelector('[data-st-mode]').addEventListener('change', function (e) { state.mode = e.target.value; renderPreview(); });
    root.querySelector('[data-st-addcond]').addEventListener('click', function () {
      if (state.conditions.length >= 3) return;
      state.conditions.push({ field: 'type', op: 'eq', value: '' });
      render();
    });
    root.querySelector('[data-st-tagadd]').addEventListener('click', addTag);
    tagInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addTag(); } });

    var PRESETS = {
      sale: { mode: 'all', conditions: [{ field: 'compareAt', op: 'notempty', value: '' }], tags: ['sale'] },
      soldout: { mode: 'all', conditions: [{ field: 'inventory', op: 'eq', value: '0' }], tags: ['sold-out'] },
      premium: { mode: 'all', conditions: [{ field: 'price', op: 'gt', value: '100' }, { field: 'status', op: 'eq', value: 'Active' }], tags: ['premium'] },
      lowstock: { mode: 'all', conditions: [{ field: 'inventory', op: 'gt', value: '0' }, { field: 'inventory', op: 'lt', value: '6' }], tags: ['low-stock'] },
      clearance: { mode: 'all', conditions: [{ field: 'price', op: 'lt', value: '30' }], tags: ['clearance'] },
      midrange: { mode: 'all', conditions: [{ field: 'price', op: 'gt', value: '30' }, { field: 'price', op: 'lt', value: '100' }], tags: ['mid-range'] },
      fullprice: { mode: 'all', conditions: [{ field: 'compareAt', op: 'empty', value: '' }], tags: ['full-price'] },
      draft: { mode: 'all', conditions: [{ field: 'status', op: 'eq', value: 'Draft' }], tags: ['draft'] },
      attention: { mode: 'any', conditions: [{ field: 'inventory', op: 'eq', value: '0' }, { field: 'status', op: 'eq', value: 'Draft' }], tags: ['needs-attention'] },
      hoodies: { mode: 'all', conditions: [{ field: 'type', op: 'eq', value: 'Hoodies' }], tags: ['hoodies', 'winter'] },
      brand: { mode: 'all', conditions: [{ field: 'vendor', op: 'eq', value: 'Northwind Apparel' }], tags: ['brand-northwind'] },
      summit: { mode: 'all', conditions: [{ field: 'name', op: 'contains', value: 'Summit' }], tags: ['summit-range'] }
    };
    root.querySelectorAll('[data-st-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = PRESETS[btn.dataset.stPreset];
        if (!p) return;
        state.mode = p.mode;
        state.conditions = p.conditions.map(function (c) { return { field: c.field, op: c.op, value: c.value }; });
        state.tags = p.tags.slice();
        root.querySelector('[data-st-mode]').value = p.mode;
        render();
      });
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.fq-item').forEach(function (item) {
      var q = item.querySelector('.fq-q');
      q.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pr-tabs]').forEach(function (tabs) {
      var root = tabs.closest('.pr-plans');

      // Map URL hashes to the app each tab controls.
      var hashMap = {
        'super-tags': 'super-tags',
        'super-checkout': 'checkout-styler',
        'checkout-styler': 'checkout-styler'
      };

      // Canonical hash written to the URL for each app.
      var appHash = {
        'super-tags': 'super-tags',
        'checkout-styler': 'super-checkout'
      };

      function activate(app) {
        var matched = false;
        tabs.querySelectorAll('.mag-tab').forEach(function (b) {
          var on = b.dataset.app === app;
          b.classList.toggle('is-active', on);
          if (on) matched = true;
        });
        if (!matched) return;
        root.querySelectorAll('[data-pr-group]').forEach(function (g) {
          if (g.dataset.prGroup === app) g.removeAttribute('hidden');
          else g.setAttribute('hidden', '');
        });
      }

      tabs.querySelectorAll('.mag-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activate(btn.dataset.app);
          var hash = appHash[btn.dataset.app];
          if (hash) history.replaceState(null, '', '#' + hash);
        });
      });

      function applyHash() {
        var app = hashMap[(window.location.hash || '').replace('#', '')];
        if (app) activate(app);
      }

      applyHash();
      window.addEventListener('hashchange', applyHash);
    });

    document.querySelectorAll('[data-pr-billing]').forEach(function (seg) {
      var root = seg.closest('.pr-plans');
      function apply(mode) {
        root.querySelectorAll('.pr-plan__price').forEach(function (price) {
          var amt = price.querySelector('.pr-plan__amt');
          var per = price.querySelector('.pr-plan__per');
          var a = price.getAttribute('data-' + mode + '-amt');
          var p = price.getAttribute('data-' + mode + '-per');
          if (a != null && amt) amt.textContent = a;
          if (p != null && per) per.textContent = p;
        });
        root.querySelectorAll('.pr-plan__save').forEach(function (s) {
          if (mode === 'yearly') s.removeAttribute('hidden');
          else s.setAttribute('hidden', '');
        });
      }
      seg.querySelectorAll('.pr-billing__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          seg.querySelectorAll('.pr-billing__opt').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          apply(btn.dataset.billing);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-tags-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-st-pi]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var PRODUCTS = [
      {
        key: 'aurora',
        name: 'Aurora Linen Shirt',
        meta: 'Shirts · Magnetar Design',
        tags: ['linen', 'summer'],
        applied: {},
        fields: {
          title: 'Aurora Linen Shirt', handle: 'aurora-linen-shirt', type: 'Shirts',
          vendor: 'Magnetar Design', status: 'ACTIVE',
          description: 'Breathable linen shirt in a relaxed cut.',
          inventory: 42, price: '89.00', compareAt: '', collection: 'Summer Edit',
          options: 'Size, Color', category: 'Shirts', variants: '4 variants'
        }
      },
      {
        key: 'tote',
        name: 'Coastal Canvas Tote',
        meta: 'Bags · Magnetar Design',
        tags: ['canvas', 'in-stock', 'on-sale', 'gift'],
        applied: { 'in-stock': 1, 'on-sale': 1, 'gift': 1 },
        fields: {
          title: 'Coastal Canvas Tote', handle: 'coastal-canvas-tote', type: 'Bags',
          vendor: 'Magnetar Design', status: 'ACTIVE',
          description: 'Heavy canvas tote for beach days and markets.',
          inventory: 18, price: '39.00', compareAt: '49.00', collection: 'Carry',
          options: 'Color', category: 'Bags', variants: '2 variants'
        }
      },
      {
        key: 'candle',
        name: 'Ember Soy Candle',
        meta: 'Home · Magnetar Design',
        tags: ['in-stock', 'gift'],
        applied: { 'in-stock': 1 },
        fields: {
          title: 'Ember Soy Candle', handle: 'ember-soy-candle', type: 'Home',
          vendor: 'Magnetar Design', status: 'ACTIVE',
          description: 'Hand-poured soy candle with a smoky amber scent.',
          inventory: 0, price: '24.00', compareAt: '32.00', collection: 'Home & Gifting',
          options: 'Scent', category: 'Candles', variants: '3 variants'
        }
      }
    ];

    var RULES = {
      instock: {
        tag: 'in-stock',
        sentence: 'WHEN <b>Total Inventory</b> is greater than <b>0</b> THEN tag <b>in-stock</b>',
        test: function (p) { return p.fields.inventory > 0; }
      },
      sale: {
        tag: 'on-sale',
        sentence: 'WHEN <b>Compare At Price</b> is not empty THEN tag <b>on-sale</b>',
        test: function (p) { return p.fields.compareAt !== ''; }
      },
      gift: {
        tag: 'gift',
        sentence: 'WHEN <b>Price</b> is less than <b>30</b> THEN tag <b>gift</b>',
        test: function (p) { return parseFloat(p.fields.price) < 30; }
      }
    };

    var FIELDS = [
      { label: 'Title', desc: "The product's name.", path: 'product.title', key: 'title' },
      { label: 'Handle', desc: 'URL-safe slug.', path: 'product.handle', key: 'handle' },
      { label: 'Product Type', desc: 'Merchant-defined type.', path: 'product.productType', key: 'type' },
      { label: 'Vendor', desc: 'Product vendor / brand.', path: 'product.vendor', key: 'vendor' },
      { label: 'Tags', desc: 'Existing tags on the product.', path: 'product.tags', key: 'tags' },
      { label: 'Status', desc: 'Whether the product is published and buyable.', path: 'product.status', key: 'status' },
      { label: 'Description', desc: 'Body / description text.', path: 'product.description', key: 'description' },
      { label: 'Category', desc: 'Shopify standard category.', path: 'product.category.name', key: 'category', plus: true },
      { label: 'Total Inventory', desc: 'Sum of variant inventory.', path: 'product.totalInventory', key: 'inventory' },
      { label: 'Price', desc: 'Lowest variant price.', path: 'product.priceRangeV2.minVariantPrice.amount', key: 'price' },
      { label: 'Compare At Price', desc: 'Pre-sale price, if the product is discounted.', path: 'product.compareAtPriceRange.minVariantCompareAtPrice.amount', key: 'compareAt' },
      { label: 'Collection', desc: 'Any collection it belongs to.', path: 'product.collections.title', key: 'collection' },
      { label: 'Options', desc: 'Option names (Size, Color...).', path: 'product.options', key: 'options' },
      { label: 'Variants', desc: 'Loop over variants in Liquid.', path: 'product.variants', key: 'variants' }
    ];

    var state = { rule: 'instock', inspected: 'aurora', query: '' };

    var itemsWrap = root.querySelector('[data-st-pi-items]');
    var fieldsWrap = root.querySelector('[data-st-pi-fields]');
    var sentenceEl = root.querySelector('[data-st-pi-sentence]');
    var exNameEl = root.querySelector('[data-st-pi-exname]');
    var searchInput = root.querySelector('[data-st-pi-search]');

    function productByKey(k) {
      for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].key === k) return PRODUCTS[i];
      return PRODUCTS[0];
    }

    // Outcome of the active rule for one product, using the same model as the
    // app: matching items gain the tag (or keep it), and on a miss only tags
    // Super Tags itself applied are removed - never the merchant's own.
    function outcome(p) {
      var rule = RULES[state.rule];
      var hasTag = p.tags.indexOf(rule.tag) !== -1;
      if (rule.test(p)) return hasTag ? 'keep' : 'add';
      if (hasTag && p.applied[rule.tag]) return 'remove';
      return 'none';
    }

    function renderItems() {
      var rule = RULES[state.rule];
      sentenceEl.innerHTML = rule.sentence;
      itemsWrap.innerHTML = '';

      PRODUCTS.forEach(function (p) {
        var out = outcome(p);
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'st-pi__item' + (p.key === state.inspected ? ' is-inspecting' : '');
        card.setAttribute('aria-label', 'Inspect ' + p.name + ' in the field explorer');

        var top = document.createElement('div');
        top.className = 'st-pi__itemtop';
        var id = document.createElement('div');
        var name = document.createElement('div');
        name.className = 'st-pi__iname'; name.textContent = p.name;
        var meta = document.createElement('div');
        meta.className = 'st-pi__imeta'; meta.textContent = p.meta;
        id.appendChild(name); id.appendChild(meta);
        top.appendChild(id);
        if (p.key === state.inspected) {
          var pill = document.createElement('span');
          pill.className = 'st-pi__inspecting'; pill.textContent = 'Inspecting';
          top.appendChild(pill);
        }
        card.appendChild(top);

        var label = document.createElement('div');
        label.className = 'st-pi__ilabel'; label.textContent = 'Current tags';
        card.appendChild(label);

        var tags = document.createElement('div');
        tags.className = 'st-pi__itags';
        p.tags.forEach(function (t) {
          var el = document.createElement('span');
          if (t === rule.tag && out === 'keep') { el.className = 'st-pi__itag st-pi__itag--keep'; el.textContent = '✓ ' + t; }
          else if (t === rule.tag && out === 'remove') { el.className = 'st-pi__itag st-pi__itag--remove'; el.textContent = '- ' + t; }
          else { el.className = 'st-pi__itag'; el.textContent = t; }
          tags.appendChild(el);
        });
        if (out === 'add') {
          var add = document.createElement('span');
          add.className = 'st-pi__itag st-pi__itag--add'; add.textContent = '+ ' + rule.tag;
          tags.appendChild(add);
        }
        card.appendChild(tags);

        var verdicts = {
          add: 'Matches - this tag will be added.',
          keep: 'Already tagged - no change.',
          remove: "No longer matches - this rule's tags will be removed.",
          none: "Doesn't match - no change."
        };
        var v = document.createElement('div');
        v.className = 'st-pi__iverdict st-pi__iverdict--' + out;
        v.textContent = verdicts[out];
        card.appendChild(v);

        card.addEventListener('click', function () {
          state.inspected = p.key;
          renderItems();
          renderFields();
        });
        itemsWrap.appendChild(card);
      });
    }

    function fieldValue(p, f) {
      if (f.key === 'tags') return p.tags.join(', ');
      var v = p.fields[f.key];
      return v === '' || v === null || v === undefined ? '' : String(v);
    }

    function renderFields() {
      var p = productByKey(state.inspected);
      exNameEl.textContent = p.name;
      fieldsWrap.innerHTML = '';

      var q = state.query.trim().toLowerCase();
      var shown = 0;
      FIELDS.forEach(function (f) {
        if (q) {
          var hay = (f.label + ' ' + f.desc + ' ' + f.path).toLowerCase();
          if (hay.indexOf(q) === -1) return;
        }
        shown++;
        var cell = document.createElement('div');
        cell.className = 'st-pi__field';

        var name = document.createElement('div');
        name.className = 'st-pi__fname'; name.textContent = f.label;
        if (f.plus) {
          var badge = document.createElement('span');
          badge.className = 'st-pi__fplus'; badge.textContent = 'PLUS';
          name.appendChild(badge);
        }
        var desc = document.createElement('div');
        desc.className = 'st-pi__fdesc'; desc.textContent = f.desc;

        var row = document.createElement('div');
        row.className = 'st-pi__frow';
        var path = document.createElement('span');
        path.className = 'st-pi__fpath'; path.textContent = f.path; path.title = f.path;
        var val = document.createElement('span');
        var value = fieldValue(p, f);
        val.className = 'st-pi__fval' + (value === '' ? ' is-empty' : '');
        val.textContent = value === '' ? '-' : value;
        val.title = value;
        row.appendChild(path); row.appendChild(val);

        cell.appendChild(name); cell.appendChild(desc); cell.appendChild(row);
        fieldsWrap.appendChild(cell);
      });

      if (!shown) {
        var empty = document.createElement('div');
        empty.className = 'st-pi__fempty';
        empty.textContent = 'No fields match "' + state.query.trim() + '".';
        fieldsWrap.appendChild(empty);
      }
      syncRules();
    }

    function syncRules() {
      root.querySelectorAll('[data-st-pi-rule]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.stPiRule === state.rule);
      });
    }

    root.querySelectorAll('[data-st-pi-rule]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.rule = btn.dataset.stPiRule;
        renderItems();
        syncRules();
      });
    });
    searchInput.addEventListener('input', function () {
      state.query = searchInput.value;
      renderFields();
    });

    renderItems();
    renderFields();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-tags-tag-kinds"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.st-kinds__tabs').forEach(function (tablist) {
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    var root = tablist.closest('.st-kinds');

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        root.querySelector('#' + t.getAttribute('aria-controls')).hidden = !active;
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // FAQ tab switching
    document.querySelectorAll('[data-su-faq-tabs]').forEach(function (tabs) {
      var scope = tabs.closest('.su-body');
      tabs.querySelectorAll('.mag-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          tabs.querySelectorAll('.mag-tab').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          scope.querySelectorAll('[data-su-faq-group]').forEach(function (g) {
            if (g.dataset.suFaqGroup === btn.dataset.faq) g.removeAttribute('hidden');
            else g.setAttribute('hidden', '');
          });
        });
      });
    });

    // FAQ accordion (single-open per group)
    document.querySelectorAll('.su-faq__item').forEach(function (item) {
      var q = item.querySelector('.su-faq__q');
      q.addEventListener('click', function () {
        var group = item.closest('.su-faq');
        var wasOpen = item.classList.contains('is-open');
        group.querySelectorAll('.su-faq__item').forEach(function (it) { it.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutorial"] && !Shopify.designMode) return;
  try {
    
  // Liquid syntax highlighting for code blocks - a direct port of the app's
  // editor highlighter (liquidHighlight.ts), same palette and token rules,
  // so docs code looks identical to code in Super Tags itself.
  (function () {
    var C = { delim: '#8b7dff', tag: '#ff9cc8', string: '#b8e56a', number: '#f0a367', op: '#7fd9e8', filter: '#ffcb6b', prop: '#82aaff', comment: '#6a6580', plain: '#e7e3f5' };
    // Liquid delimiters are assembled by concatenation - writing one literally
    // in this block would be parsed as a Liquid tag by the theme itself.
    var TAG_OPEN = '{' + '%';
    var VAR_OPEN = '{' + '{';
    var CMT_OPEN = '{' + '#';
    var BLOCK_RE = new RegExp(TAG_OPEN + '-?[\\s\\S]*?-?%\\}|' + VAR_OPEN + '-?[\\s\\S]*?-?\\}\\}|' + CMT_OPEN + '[\\s\\S]*?#\\}', 'g');
    var KEYWORDS = ['if', 'elsif', 'else', 'endif', 'unless', 'endunless', 'case', 'when', 'endcase', 'for', 'endfor', 'break', 'continue', 'cycle', 'tablerow', 'endtablerow', 'assign', 'capture', 'endcapture', 'increment', 'decrement', 'include', 'render', 'comment', 'endcomment', 'raw', 'endraw', 'liquid', 'echo', 'section', 'add_tag', 'remove_tag'];
    var OPERATORS = ['and', 'or', 'contains', 'in', 'with', 'as', 'by', 'limit', 'offset', 'reversed'];
    var CONSTS = ['true', 'false', 'nil', 'null', 'empty', 'blank'];

    function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function span(color, text, italic) { return '<span style="color:' + color + (italic ? ';font-style:italic' : '') + '">' + esc(text) + '</span>'; }

    function highlightInner(inner, isTag) {
      var out = '';
      var tok = /(\s+)|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*")|(\d+\.?\d*)|([A-Za-z_][A-Za-z0-9_]*)|([|.:=<>!?]+|[(),[\]])|(.)/g;
      var firstWord = isTag;
      var prev = '';
      var m;
      while ((m = tok.exec(inner))) {
        if (m[1]) { out += esc(m[1]); continue; }
        if (m[2]) { out += span(C.string, m[2]); prev = 'str'; continue; }
        if (m[3]) { out += span(C.number, m[3]); prev = 'num'; continue; }
        if (m[4]) {
          var w = m[4], color;
          if (firstWord) color = C.tag;
          else if (prev === '|') color = C.filter;
          else if (prev === '.') color = C.prop;
          else if (KEYWORDS.indexOf(w) !== -1) color = C.tag;
          else if (OPERATORS.indexOf(w) !== -1) color = C.op;
          else if (CONSTS.indexOf(w) !== -1) color = C.number;
          else color = C.plain;
          out += span(color, w);
          firstWord = false;
          prev = w;
          continue;
        }
        if (m[5]) { out += span(C.op, m[5]); prev = m[5]; continue; }
        out += esc(m[6]); prev = m[6];
      }
      return out;
    }

    function highlightBlock(block) {
      var isTag = block.indexOf(TAG_OPEN) === 0;
      var open = (block.match(/^\{[%{]-?/) || [''])[0];
      var close = (block.match(/-?[%}]\}$/) || [''])[0];
      var inner = block.slice(open.length, block.length - close.length);
      return span(C.delim, open) + highlightInner(inner, isTag) + span(C.delim, close);
    }

    function highlightLiquid(src) {
      var out = '';
      var last = 0;
      BLOCK_RE.lastIndex = 0;
      var m;
      while ((m = BLOCK_RE.exec(src))) {
        if (m.index > last) out += span(C.plain, src.slice(last, m.index));
        var block = m[0];
        out += block.indexOf(CMT_OPEN) === 0 ? span(C.comment, block, true) : highlightBlock(block);
        last = m.index + block.length;
      }
      if (last < src.length) out += span(C.plain, src.slice(last));
      return out;
    }

    document.querySelectorAll('.tutorial-body pre code').forEach(function (code) {
      var src = code.textContent;
      if (src.indexOf(TAG_OPEN) !== -1 || src.indexOf(VAR_OPEN) !== -1) code.innerHTML = highlightLiquid(src);
    });
  })();

  // Build the "On this page" nav from the article's h2s: assign each a
  // slug id, link to it, and scroll-spy the one currently in view.
  (function () {
    var toc = document.querySelector('[data-tutorial-toc]');
    var article = document.querySelector('.tutorial-body');
    if (!toc || !article) return;

    var headings = Array.prototype.slice.call(article.querySelectorAll('h2'));
    if (!headings.length) { var nav = toc.closest('.tutorial-nav'); if (nav) nav.style.display = 'none'; return; }

    var seen = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var slug = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
        if (seen[slug]) slug += '-' + seen[slug]++; else seen[slug] = 1;
        h.id = slug;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      toc.appendChild(li);
    });

    var links = toc.querySelectorAll('a');
    function setActive(id) {
      links.forEach(function (a) { a.classList.toggle('is-active', a.hash === '#' + id); });
    }
    setActive(headings[0].id);

    if ('IntersectionObserver' in window) {
      var current = headings[0].id;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) current = e.target.id; });
        setActive(current);
      }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
      headings.forEach(function (h) { observer.observe(h); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
